
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11 10h26a3 3 0 013 3v22a3 3 0 01-3 3H11a3 3 0 01-3-3V13a3 3 0 013-3z","opacity":".202"}}),_c('path',{attrs:{"fill":"#8B96B8","d":"M37 10a3 3 0 013 3v22a3 3 0 01-3 3H11a3 3 0 01-3-3V13a3 3 0 013-3h26zm0 1H11a2 2 0 00-2 2v22a2 2 0 002 2h26a2 2 0 002-2V13a2 2 0 00-2-2zM24.192 27.878a2.153 2.153 0 11-.001 4.306 2.153 2.153 0 010-4.306zm0 1a1.153 1.153 0 10.001 2.306 1.153 1.153 0 00-.001-2.306zm0-5.143a6.055 6.055 0 015.084 2.755.5.5 0 01-.838.545 5.055 5.055 0 00-4.247-2.3c-1.734 0-3.32.876-4.245 2.3a.5.5 0 11-.839-.545 6.056 6.056 0 015.084-2.755zm0-4.13a9.757 9.757 0 017.345 3.316.5.5 0 01-.75.661 8.757 8.757 0 00-6.595-2.977 8.766 8.766 0 00-6.595 2.984.5.5 0 01-.75-.662 9.765 9.765 0 017.345-3.322zM24.16 15.5c3.652 0 7.071 1.453 9.581 3.99a.5.5 0 01-.71.703 12.434 12.434 0 00-8.871-3.693c-3.345 0-6.481 1.32-8.807 3.63a.5.5 0 01-.704-.71c2.51-2.494 5.899-3.92 9.51-3.92z"}})])])
          )
        }
      }
    